export const declineOrderOptions = {
    cannotDeliverOnThisDate: "cannotDeliverOnThisDate",
    doesNotDeliverToThisAddress: "doesNotDeliverToThisAddress",
    missingProductInOrder: "missingProductInOrder",
    missingCustomerDetails: "missingCustomerDetails",
    other: "Other"
};

export const declineOrderOptionsToText = {
    [declineOrderOptions.cannotDeliverOnThisDate]: "לא יכול לספק בתאריך הזה",
    [declineOrderOptions.doesNotDeliverToThisAddress]: "לא מגיע לכתובת שהוזנה",
    [declineOrderOptions.missingProductInOrder]: "חסר מוצר מתוך ההזמנה",
    [declineOrderOptions.missingCustomerDetails]: "חסרים פרטים של הלקוח",
    [declineOrderOptions.other]: "אחר"
};

export const briefDeclineOptions = {
    closedOrderAnotherWay: "closedOrderAnotherWay",
    eventChanged: "eventChanged",
    offersNotRelevant: "offersNotRelevant",
    longResponseTime: "longResponseTime",
    other: "other"
};

export const briefDeclineOptionsToText = {
    [briefDeclineOptions.closedOrderAnotherWay]: "סגרתי את ההזמנה בדרך אחרת",
    [briefDeclineOptions.eventChanged]: "האירוע שונה",
    [briefDeclineOptions.offersNotRelevant]: "ההצעות שקיבלתי לא רלוונטיות",
    [briefDeclineOptions.longResponseTime]: "זמן מענה ארוך",
    [briefDeclineOptions.other]: "אחר"
};

export const briefProviderDeclineOptions = {
    shortNoticeTime: "shortNoticeTime",
    doesNotShipToAddress: "doesNotShipToAddress",
    clientBudgetTooLow: "clientBudgetTooLow",
    specialRequestsTooExpensive: "specialRequestsTooExpensive",
    other: "other"
};

export const briefProviderDeclineOptionsToText = {
    [briefProviderDeclineOptions.shortNoticeTime]: "זמן התראה קצר מדי",
    [briefProviderDeclineOptions.doesNotShipToAddress]: "לא משלח לכתובת הזו",
    [briefProviderDeclineOptions.clientBudgetTooLow]: "תקציב לקוח נמוך מדי",
    [briefProviderDeclineOptions.specialRequestsTooExpensive]: "בקשות מיוחדות שמייקרות את ההצעה",
    [briefProviderDeclineOptions.other]: "אחר"
};

export const BRIEF_DECLINE_MODAL_HEADER = "יש להוסיף את סיבת ביטול הבריף";
export const BRIEF_DECLINE_MODAL_SUBTITLE =
    "נשמח להבין מה הוביל לביטול הבריף, כדי שנוכל לשפר את תהליך בניית הבריפים עבורך בהמשך";

export const PROVIDER_BRIEF_DECLINE_MODAL_HEADER = "יש להוסיף את סיבת הסרת ההשתתפות להצעת מחיר";
export const PROVIDER_BRIEF_DECLINE_MODAL_SUBTITLE =
    "אנחנו רוצים להבין למה בחרת שלא להגיש הצעת מחיר, כדי שנוכל לדייק עבורך את ההצעות הבאות";
